import { createContext, useContext, useState } from "react";

import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

// create context for managing success
const Context = createContext({
  setSuccess: (message: string) => {},
});

// custom hook to use the success context
export const useSuccess = () => useContext(Context);

// banner component
const Banner = (props: { message: string; clear: () => void }) => {
  const { message, clear } = props;

  return (
    <Snackbar
      key={message}
      open={!!message}
      onClose={clear}
      autoHideDuration={10000}
    >
      <Alert onClose={clear} severity="success">
        {message}
      </Alert>
    </Snackbar>
  );
};

// success provider component
const SuccessProvider = ({ children }: { children: any }) => {
  const [message, setMessage] = useState("");

  // function to set success
  const setHandler = (message: string) => setMessage(message);

  return (
    <Context.Provider value={{ setSuccess: setHandler }}>
      {children}
      <Banner message={message} clear={() => setMessage("")} />
    </Context.Provider>
  );
};

export default SuccessProvider;
